import FormComponent from "./Form.component";
import { componentWithAddedProp } from "../../utils/generalUtils";
import {
  publicationFieldsConfig,
  courseFieldsConfig,
  currentStudentFieldsConfig,
  educationFieldsConfig,
  formerStudentFieldsConfig,
  researchFundingFieldsConfig,
  researchInterestFieldsConfig,
  awardFieldsConfig,
  academicPositionFieldsConfig,
  editorialAppointmentsFieldsConfig,
} from "./columnConfig";
import {
  publicationsDb,
  courseDb,
  academicPositionsDb,
  awardsDb,
  currentStudentDb,
  educationDb,
  formerStudentsDb,
  researchFundingDb,
  researchInterestDb,
  editorialAppointmentsDb,
} from "../../db/dbClasses";

const formWithConfig = (fieldsConfig, db) => {
  return componentWithAddedProp(FormComponent, {
    fieldsConfig,
    db,
  });
};

const PublicationsForm = formWithConfig(
  publicationFieldsConfig,
  publicationsDb
);
const CoursesForm = formWithConfig(courseFieldsConfig, courseDb);
const CurrentStudentsForm = formWithConfig(
  currentStudentFieldsConfig,
  currentStudentDb
);
const EducationForm = formWithConfig(educationFieldsConfig, educationDb);
const FormerStudentForm = formWithConfig(
  formerStudentFieldsConfig,
  formerStudentsDb
);
const ResearchFundingForm = formWithConfig(
  researchFundingFieldsConfig,
  researchFundingDb
);
const ResearchInterestForm = formWithConfig(
  researchInterestFieldsConfig,
  researchInterestDb
);
const AwardForm = formWithConfig(awardFieldsConfig, awardsDb);
const AcademicPositionForm = formWithConfig(
  academicPositionFieldsConfig,
  academicPositionsDb
);
const EditorialAppointmentsForm = formWithConfig(
  editorialAppointmentsFieldsConfig,
  editorialAppointmentsDb
);

export {
  PublicationsForm,
  CoursesForm,
  CurrentStudentsForm,
  EducationForm,
  FormerStudentForm,
  ResearchFundingForm,
  ResearchInterestForm,
  AwardForm,
  AcademicPositionForm,
  EditorialAppointmentsForm,
};
